import { type PropsWithChildren } from "react";

import { type TableSelection } from "@devexpress/dx-react-grid-bootstrap4";
import { CustomCheckbox } from "@shared/custom-checkbox";

export const TableSelectionCell = ({
  selected,
  row,
  onToggle,
  tableRow,
  tableColumn,
  ...restOfProps
}: PropsWithChildren<TableSelection.CellProps>) => {
  return (
    <td className="sticky left-0" {...restOfProps}>
      <div
        className="flex items-center justify-center w-full h-full bg-v2-primary"
        onClick={() => {
          onToggle();
        }}
      >
        <CustomCheckbox className="pointer-events-none" checked={selected} />
      </div>
    </td>
  );
};
